module.exports = __webpack_public_path__ + "static/media/2.be0775d5.svg";